import { Injectable } from '@angular/core';
import { Reservation } from '../interfaces/reservation';
import { RestApiService } from './rest-api.service';
import * as moment from 'moment';
import { DateService } from './date.service';

@Injectable({
    providedIn: 'root'
})
export class ClotureService {

    reservations: Array<Reservation> = [];
    reservationCount: number = 0;
    maxPages: number = 1;
    pageSize: number = 16;

    constructor(
        private api: RestApiService,
        private dateService: DateService
    ) { }

    selectBookingPeriods(idEquipment, start, end): Promise<any> {

        const header = {
            'Content-Type': 'application/json',
            'Authorization': 'Basic Basic bW9kdWxhdXRvOm1vZHVsYXV0bw=='
        }

        return new Promise((resolve, reject) => {
            // this.api.get(`/MI_GALAGO/REST/SelectBookingPeriodsV2`, {}, false).then((res) => {
            //     resolve(res);
            // });
            return fetch("http://modulauto.homedns.org:8080/WS_ALPHA/MI_GALAGO/REST/SelectBookingPeriodsV2?idEquipment=52&start=2022-08-29T22%3A00%3A00.000Z&end=2022-08-30T21%3A00%3A00.000Z", {
                method: 'GET',
                headers: header
            })
                .then(response => response.json())
        });
    }

    clotureReservationAdmin(start, end, idEquipment = null): Promise<any> {
        let body = {
            start,
            end
        }

        if (idEquipment) {
            body[idEquipment] = idEquipment
        }

        return this.api.post('/WS/MI_BO_MTICKET/REST/booking/close/administrator', body, true).then((res) => {
            console.log("Cloture Resa Admin", res);
            return res;
        })
    }
}
